
























































import { Component, Mixins } from "vue-property-decorator";
import { Department } from "../../../domain/department";
import { IMultiSelectableAsynchronously, IMultiSelectableConditionallyAsynchronously } from "../../system/selectors";
import MultiOrderableDepartmentListSelector from "../selectors/MultiOrderableDepartmentListSelector.vue";
import { IDepartmentListSelectorDialogCondition, instanceOfIDepartmentListSelectorDialogCondition } from "./IDepartmentListSelectorDialogCondition";
import { instanceOfIMultiDepartmentListSelectorDialogCondition } from "./IMultiDepartmentListSelectorDialogCondition";
import { DepartmentSelectableDialogMixin } from "./mixins";

@Component({
  components: {
    MultiOrderableDepartmentListSelector,
  },
})
export default class MultiOrderableDepartmentListSelectorDialog extends Mixins(DepartmentSelectableDialogMixin) implements IMultiSelectableAsynchronously<Department>, IMultiSelectableConditionallyAsynchronously<Department, IDepartmentListSelectorDialogCondition> {
  get selectionMaxCount(): number {
    return this.$configuration.behavior.department.multiSelector.max;
  }

  get additionMaxCount(): number {
    return this.$configuration.behavior.department.multiSelector.addition.max;
  }

  get isOverSelectionMaxCount(): boolean {
    return this.selected && this.selected.length > this.selectionMaxCount;
  }

  get isSelectable(): boolean {
    return this.hasSelected && !this.isOverSelectionMaxCount;
  }

  async selectOptions(defaultOptions?: Department[]): Promise<Department[]> {
    return this.show<Department[]>(defaultOptions);
  }

  async selectOptionsConditionally(condition?: IDepartmentListSelectorDialogCondition, defaultOptions?: Department[]): Promise<Department[]> {
    if (instanceOfIDepartmentListSelectorDialogCondition(condition)) {
      this.name = condition.name ? condition.name : "";
      this.nonDisplayDepartmentCodes = condition.nonDisplayDepartmentCodes ? condition.nonDisplayDepartmentCodes : null;
      this.departmentGroup = condition.departmentGroup;
    }
    if (instanceOfIMultiDepartmentListSelectorDialogCondition(condition)) {
      this.defaultMultiSelect = condition.isMultiSelectable;
    }
    return this.show<Department[]>(defaultOptions);
  }

  onDblClicked(selectedOption: Department): void {
    this.select(selectedOption);
  }
}
